import { defineStore } from 'pinia'

export const useDeviceStore = defineStore('device', {
  state: () => ({
    isMobile: false
  }),
  actions: {
    checkDevice() {
      this.isMobile = window.innerWidth <= 640
    }
  }
})
